import { useState } from "react";
import FailedPayments from "./FailedPayments";
import PaymentsMade from "./PaymentsMade";
import "./BillingAndPayments.css"
import Refunds from "./Refunds";
import SideMenu from "../../components/SideMenu";
import ClubPortals from "./ClubPortals";
export default function BillingAndPayments() {
  const [currentView, setCurrentView] = useState("Paymentsmade");
  return (
    <div className="container">


<div className="row hideAt1300">
        <div className="col-3 side-menu-container">
          <SideMenu />
        </div>
        <div className="col bg-white mx-5 my-2 p-0 ">
          <div className="blueBanner">
            <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
              Billing and Payments
            </p>
          </div>
          <div className="d-flex justify-content-end">
          <button  onClick={() => setCurrentView("Clubs")} className="settings-menu-button">Clubs</button>
          <button  onClick={() => setCurrentView("Paymentsmade")} className="settings-menu-button">Payments made</button>
           <button    onClick={() => setCurrentView("Refunds")} className="settings-menu-button">Refunds</button>
              <button  onClick={() => setCurrentView("FailedPayments")} className="settings-menu-button"> Failed Payments</button>
          </div>

          <div className="mx-2">
          {currentView == "Clubs" && <ClubPortals />}
          {currentView == "FailedPayments" && <FailedPayments />}
        {currentView == "Paymentsmade" && <PaymentsMade />}
        {currentView == "Refunds" && <Refunds />}
          </div>
        </div>

       
      </div>
      <div className="showAt1300">
      <div className="bg-white my-2 p-0 ">
          <div className="blueBanner">
            <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
              Billing and Payments
            </p>
          </div>
          <div className="text-center">
          <button  onClick={() => setCurrentView("Clubs")} className="settings-menu-button">Clubs</button>
          <button  onClick={() => setCurrentView("Paymentsmade")} className="settings-menu-button-stacked">Payments made</button>
           <button    onClick={() => setCurrentView("Refunds")} className="settings-menu-button-stacked">Refunds</button>
              <button  onClick={() => setCurrentView("FailedPayments")} className="settings-menu-button-stacked"> Failed Payments</button>
          </div>

          <div className="mx-2">
          {currentView == "Clubs" && <ClubPortals />}
          {currentView == "FailedPayments" && <FailedPayments />}
        {currentView == "Paymentsmade" && <PaymentsMade />}
        {currentView == "Refunds" && <Refunds />}
          </div>
        </div>
        </div>
    </div>
  );
}
